import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom-v5-compat";
import { useMyMealsMenuContext } from "../../../../../MyMeals/MyMealsMenuContext/MyMealsMenuContext";
import { useCompany } from "../../../../../Shared/components/CompanyProvider/CompanyProvider";
import { chooseOrReviewMealsButtonClickHandler, getChooseOrReviewMealsButtonText, } from "../../../../../Shared/components/Navigation/navigationUtils";
// ** Button component for choosing or reviewing meals.
export const ChooseOrReviewMealsBtn = ({ showMealsButton, HasMenuSet, OrderIsUpcoming, orderNumber, subscriptionLinkId, AllMealDaysPastCutOff, mappedMeals, orderIsSkipped, }) => {
    const navigate = useNavigate();
    const { tokenMap } = useCompany();
    const { setSelectedSubLinkId } = useMyMealsMenuContext();
    // Conditions determining the button's state and behavior.
    const canReviewOrChooseMeals = showMealsButton && !OrderIsUpcoming; // user can review or choose meals if the order isn't upcoming.
    const canChooseMeals = showMealsButton && OrderIsUpcoming && HasMenuSet; // user can choose meals for upcoming orders.
    const buttonText = getChooseOrReviewMealsButtonText(canReviewOrChooseMeals, AllMealDaysPastCutOff, tokenMap);
    const onClick = () => chooseOrReviewMealsButtonClickHandler(setSelectedSubLinkId, subscriptionLinkId, canReviewOrChooseMeals, navigate, orderNumber, canChooseMeals, mappedMeals);
    // Button for reviewing or choosing meals based on conditions.
    if (canReviewOrChooseMeals || canChooseMeals) {
        return (_jsx(Button, Object.assign({ size: "medium", fullWidth: true, variant: "outlined", color: "primary", 
            // Disable button if the order is skipped.
            disabled: orderIsSkipped, onClick: onClick }, { children: buttonText })));
    }
    // Return null if none of the conditions are met.
    return null;
};
